<ng-container
	*ngIf="mode === depositSideFormMode.DRAWER; else depositSideFormDefault"
>
	<div class="flex justify-between items-center">
		<div class="flex flex-col items-start justify-center">
			<div>Deposit (held by {{ depositHolderName$ | async }})</div>
		</div>
		<app-button
			btn="tertiary"
			(click)="openDepositDrawer()"
			class="ml-3"
			[testHook]="testHooks.OpenDepositDrawerButton"
			>{{ (depositTotal$ | async)?.absAmount | centsToDollars }}</app-button
		>
	</div>
	<app-deposit-drawer #depositDrawer></app-deposit-drawer>
</ng-container>

<ng-template #depositSideFormDefault>
	<div
		class="flex justify-between items-center"
		*ngIf="!skeletonLoading; else loader"
	>
		<div class="flex gap-2 items-center">
			<label>Deposit</label>
			<app-icon
				*ngIf="(fieldMappings$ | async)?.deposit"
				[icon]="AI_ICON"
				[classes]="AI_CLASSES"
				[matTooltip]="AI_TOOLTIP"
			/>
		</div>
		<app-button
			btn="tertiary"
			(click)="openDepositModal()"
			class="ml-3"
			[testHook]="testHooks.OpenDepositModalButton"
		>
			{{ (depositTotal$ | async)?.absAmount | centsToDollars }}
		</app-button>
	</div>
	<ng-template #loader>
		<ui-skeleton-loader class="w-full" type="input" />
	</ng-template>
</ng-template>
